import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import * as loadables from 'lib/loadables';
import { CircularProgress } from '@mui/material';
import storageService from 'lib/storageService';
import PublicHomepage from '../../../../components/PublicHomepage/PublicHomepage';

/** Taken from https://reacttraining.com/react-router/web/example/modal-gallery */
const ModalSwitch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = storageService.get('token');
  const isAuthenticated = !!token && token !== 'undefined' && token !== 'null';

  useEffect(() => {
    // Only redirect if user is authenticated and trying to access auth routes
    if (isAuthenticated && location.pathname.startsWith('/auth/')) {
      // Force page refresh when redirecting to dashboard
      window.location.href = '/dashboard';
    }
    // Only redirect unauthenticated users from private routes, not from public homepage
    if (!isAuthenticated && location.pathname.startsWith('/dashboard/')) {
      navigate('/auth/login');
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <Suspense fallback={<CircularProgress size={100} />}>
      <Routes location={location}>
        {/* Public Homepage */}
        <Route path="/" element={<PublicHomepage />} />

        {/* Auth Routes */}
        <Route path="/auth/*">
          <Route exact path="login" element={<loadables.LoadableLoginScreen />} />
          <Route exact path="signup" element={<loadables.LoadableSignupScreen />} />
          <Route exact path="*" element={<Navigate to={'/'} />} />
        </Route>

        {/* Private Routes */}
        <Route
          path={'/dashboard/*'}
          element={<loadables.LoadablePrivateRoutes isAuthenticated={isAuthenticated} />}
        />

        {/* Redirect authenticated users to dashboard */}
        <Route
          path={'/*'}
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/" />}
        />
      </Routes>
    </Suspense>
  );
};

export default ModalSwitch;
